import React from "react";

interface URLIconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  color?: string;
}

const URLIcon: React.FC<URLIconProps> = ({
  width = "30",
  height = "16",
  color = "#A41E35",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.084 0.916748H16.4173V3.75008H22.084C24.4215 3.75008 26.334 5.66258 26.334 8.00008C26.334 10.3376 24.4215 12.2501 22.084 12.2501H16.4173V15.0834H22.084C25.994 15.0834 29.1673 11.9101 29.1673 8.00008C29.1673 4.09008 25.994 0.916748 22.084 0.916748ZM13.584 12.2501H7.91732C5.57982 12.2501 3.66732 10.3376 3.66732 8.00008C3.66732 5.66258 5.57982 3.75008 7.91732 3.75008H13.584V0.916748H7.91732C4.00732 0.916748 0.833984 4.09008 0.833984 8.00008C0.833984 11.9101 4.00732 15.0834 7.91732 15.0834H13.584V12.2501ZM9.33398 6.58342H20.6673V9.41675H9.33398V6.58342Z"
        fill={color}
      />
    </svg>
  );
};

export default URLIcon;
